import { getEnterprise } from "helpers/backend_helper"
import useRequest from "hooks/useRequest"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { tabName } from "./components/Tabs"

const useEnterpriseDetail = () => {
  const [tabActive, setTabActive] = useState(tabName.generalData)

  const enterpriseReq = useRequest()
  const user = useSelector(state => state.Login.user)

  const fetchEnterprise = () => {
    if (!user.enterprise_id) return

    enterpriseReq.req(getEnterprise(user.enterprise_id))
  }

  useEffect(fetchEnterprise, [user?.enterprise_id])

  return {
    state: {
      tabActive,
      isLoading: enterpriseReq.isLoading,
      enterprise: enterpriseReq.data,
    },
    events: {
      setTabActive,
    },
  }
}

export default useEnterpriseDetail
